"use client";
import { Icon } from "@iconify/react";

import useSimilarBlog from "./useSimilarBlog";

import { ViewImage } from "@/components";
import { AllBlogs } from "@/types";

const SimilarBlog = () => {
    const { similarBlogs, router } = useSimilarBlog();

    return (
        <div className="mt-20">
            {similarBlogs?.length > 0 && <div className="flex items-center gap-2 mb-8">
                <Icon icon="solar:documents-outline" width={24} />
                <h2 className="text-2xl font-bold">Similar Articles</h2>
            </div>}

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {similarBlogs?.map((blog: AllBlogs) => (
                    <button
                        key={blog?._id}
                        className="group cursor-pointer"
                        onClick={() => router.push(`/blog/${blog?.slug}`)}
                    >
                        <ViewImage
                            className="h-56 w-full object-cover rounded-2xl"
                            img={blog?.featuredImage}
                        />

                        <div className="mt-4">
                            <div className="text-sm text-foreground-500">
                                {blog?.createdAt && new Date(blog?.createdAt).toDateString()}
                            </div>

                            <h3 className="font-semibold mt-2 line-clamp-2 group-hover:text-primary transition-all">
                                {blog?.title}
                            </h3>
                        </div>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default SimilarBlog;
